export default {
    filtros: {
        ordem: 'Orden',
        resultado: 'Resultado',
        origem: 'Origen',
        destino: 'Destino',
        titulo: 'Filtros',
        mostrar_filtros: 'Mostrar Filtros',
        esconder_filtros: 'Ocultar Filtros',
        nome: 'Nombre',
        codigo: 'Código',
        componente: 'Componente',
        material: 'Material',
        complement: 'Complementar',
        metodo: 'Método',
        metodos: 'Métodos',
        tempos: 'Tiempos',
        escala: 'Escala',
        integracao: 'Integración',
        detalhes: 'Detalles',
        botao_filtrar: 'Filtrar',
        integracoes: 'Integraciones',
        logs: 'Logs',
    },
    ordem: {
        titulo_pagina: 'De X Para de Orden',
        exams: {
            empty: 'Nenhum exame encontrado para os filtros informados!',
            origem: 'Exámenes de Origen',
            destino: 'Exámenes Destino',
            botao_salvar: 'Guardar',
            sucesso: '¡De x Para, guardado con éxito!'
        }
    },
    resultado: {
        titulo_pagina: 'De X Para de Resultado',
        exams: {
            empty: '¡No se encontró ningún examen para los filtros especificados!',
            origem: 'Origen de los exámenes',
            destino: 'Exámenes de destino',
            parse_personalizado: 'Análisis personalizado',
            botao_salvar: 'Guardar',
            sucesso: '¡De x Para, guardado con éxito!'
        }
    },
    metodo: {
        titulo_pagina: 'De X Para de Métodos',
        empty: '¡No se ha encontrado ningún método!',
        origem: 'Métodos de Origen',
        destino: 'Métodos de Destino',
        botao_salvar: 'Guardar',
        sucesso: '¡De x Para, guardado con éxito!'
    },
    material: {
        titulo_pagina: 'De X Para de Materiales',
        empty: '¡Ningún material encontrado!',
        origem: 'Materiales de Origen',
        destino: 'Materiales de Destino',
        botao_salvar: 'Guardar',
        sucesso: '¡De x Para, guardado con éxito!'
    },
    complement: {
        titulo_pagina: 'De X Para de Complementos',
        empty: '¡No se encontraron complementos!',
        origem: 'Complementos de Origen',
        destino: 'Complementos de Destino',
        botao_salvar: 'Guardar',
        sucesso: '¡De x Para, guardado con éxito!'
    },
    tipo: {
        titulo_pagina: 'De X Para por Tipo',
        empty: '¡Ningún artículo encontrado!',
        origem: 'Elementos de origen',
        destino: 'Elementos de Destino',
        botao_salvar: 'Guardar',
        sucesso: '¡De x Para, guardado con éxito!',
        selecione_tipo: '¡Seleccione tipo!',
        depara_sucesso: '¡De X Para\'s se registró con éxito!',
        depara_erro: 'Error al Registrar DeXPara\'s!'
    },
    exame_resultado: {
        titulo_pagina: 'De X Para el valor del resultado',
        empty: '¡No se han encontrado resultados de exámenes!',
        exame: 'Examen',
        origem: 'Origen',
        destino: 'Destino',
        selecione_exame: 'Seleccionar examen!',
        depara_sucesso: '¡De X Para\'s se registró con éxito!'
    },
    copia: {
        copiar_dexpara: 'Copiar De x A',
        tipo_integracao: 'Tipo de Integración',
        para_integracao: 'Para la integración',
        origem: 'Origen',
        destino: 'Destino',
        sucesso: 'La integración se copió exitosamente!',
        sim: 'Sí',
        nao: 'No',
        erro: {
            vazio: '¡El tipo de integración y los campos de integración deben completarse!',
            integracao_origem: '¡Se debe seleccionar la integración de origen para copiarla!',
            integracao_destino: '¡Se debe seleccionar la integración de destino para copiarla!',
            copiar: '¡Ocurrió un error al intentar copiar la integración!',
            tipo: '¡Se debe seleccionar el campo tipo para guardar la copia de integración!'
        },
        confirmacao: {
            titulo: 'Copia de Integración',
            mensagem: '¿Estás seguro de que quieres copiar esta integración?'
        }
    },
    log: {
        origem: 'Origen',
        destino: 'Destino',
        vazio: 'Sin registro de log.',
        ultimo: {
            info: 'Última edición por',
            complemento: 'el'
        }
    }
}
